// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const PropertyListContract = contract({
  name: "PropertyList",
  description: "Read-only display of the properties of a SINGLE item — detail panels, inspectors, \"about this\" cards, order/record summaries. It is a Table row transposed (schema vertical, one record). The value side is a polymorphic slot, so the same renderers that fill a Table cell (text, Badge, tag group, Avatar stack, date, link) drop straight into a row. For an EDITABLE field (label + control) use Field instead; a panel that flips between read and edit swaps a PropertyList for a stack of Fields.",
  import: "@gradeui/ui",
  aliases: ["property list","properties","property panel","description list","definition list","detail list","key value","key-value","data list","field list","attributes","metadata list","record summary","detail panel","inspector fields","spec list"],
  composesWith: ["Badge","Avatar","Table","Field","Separator","Card"],
  styleDefaults: {"PropertyListRoot":"flex min-w-0 flex-col","PropertyListRow":"grid"},
  props: {
  "layout": {
      schema: z.enum(["row", "stack"]).optional(),
      design: "knob",
      description: "row (default): label column beside value; stack: label above value for narrow panels",
  },
  "density": {
      schema: z.enum(["compact", "default", "relaxed"]).optional(),
      design: "knob",
      description: "row rhythm",
  },
  "align": {
      schema: z.enum(["start", "center"]).optional(),
      design: "knob",
      description: "default vertical alignment of label vs value; use start when values wrap (tag groups, multi-line)",
  },
  "divider": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "hairline rule between rows",
  },
  "labelWidth": {
      schema: z.string().optional(),
      design: "content",
      description: "override the label column width (any CSS length); sets --gds-property-list-label-width",
  },
  "children": {
      schema: z.unknown(),
      design: "plumbing",
  },
  },
});
